import React, { useState } from "react";

const OverviewCard = ({ data }) => {
  const [progress, setProgress] = useState(78);
  return (
    <div className="overview-card glass-card">
      <div className="trophy-progress">
        <div>
          <TrophyProgress percentage={progress} />
        </div>
      </div>
      <div className="overview-info">
        <div className="rank-info">
          <div className="overview-card-modal blue-card">
            <span>Account Rank</span>
            <h3>{data?.accountRank}</h3>
          </div>
          <div className="overview-card-modal">
            <span>Rank #</span>
            <h3>{data?.rankPosition}</h3>
          </div>
          <div className="overview-card-modal">
            <span>Tournaments</span>
            <h3>{data?.tournamentsPlayed}</h3>
          </div>
          <div className="overview-card-modal">
            <span>Trophies</span>
            <h3>{data?.trophies}</h3>
          </div>
          <div className="overview-card-modal pink-card">
            <span>Next Rank</span>
            <h3>{data?.nextRank}</h3>
          </div>
        </div>
        <div className="tasks-list">
          <div className="task-item">
            {" "}
            <span>Tasks</span>
          </div>
          <div className="task-item done">
            {" "}
            <h6>Attend {data?.taskList?.tournaments} tournaments</h6>{" "}
            <span>55/70</span>
          </div>
          <div className="task-item done">
            {" "}
            <h6>
              {data?.requiredMedals?.gold} Gold Medals,{" "}
              {data?.requiredMedals?.silver} Silver Medals and{" "}
              {data?.requiredMedals?.bronze} Bronze Medals
            </h6>{" "}
          </div>
          {/* <div className="task-item done">
            {" "}
            <h6>Full Ranked in 3 games minimum </h6> <span>3/3</span>
          </div>
          <div className="task-item">
            <h6>More than 3k followers </h6> <span>2.3k/3k</span>
          </div>
          <div className="task-item">
            {" "}
            <h6>Create 3 tutorial videos </h6>
            <span>0/3</span>
          </div>
          <div className="task-item done">
            {" "}
            <h6>Stream Live for 72 Hours </h6> <span>74/72</span>
          </div>
          <div className="task-item">
            <h6>Win 5 Special Challenges</h6> <span>4/5</span>
          </div> */}
        </div>
      </div>
    </div>
  );
};
const TrophyProgress = ({ percentage }) => {
  const [progress, setProgress] = useState(77);
  return (
    <div className="trophy-progress-wrapper">
      <div style={{ textAlign: "center" }}>
        <div className="progress-text">{progress}%</div>
        <div className="trophy-container">
          <div className="trophy-fill">
            <div
              className="fill-inner"
              style={{ height: `${progress}%` }}
            ></div>
          </div>
          <div className="trophy-outline"></div>
        </div>
      </div>
    </div>
  );
};

export default OverviewCard;
